import { IoMdUndo } from "react-icons/io";
import { IoMdRedo } from "react-icons/io";

const UndoRedoButtons = ({ onUndo, onRedo }) => {
  return (
    <div className='undo-redo-buttons'>
        < IoMdUndo onClick={onUndo} />
        < IoMdRedo onClick={onRedo} />
    </div>
  )
}

export default UndoRedoButtons